// Build-time feature flags.
//
// Flip a flag to false and rebuild to remove the feature from the UI without
// deleting any code. (The frontend is compiled, so a flag change needs a
// rebuild + ship — for an instant rollback on a live env, redeploy the
// previously-tagged Docker image instead.)

// >>> call-dibs feature (revertible) >>>
// "Call dibs": let a TA reserve a student (amber row, "help is on the way")
// without starting the help clock. Set to false to hide all dibs UI.
export const FEATURE_CALL_DIBS = true;
// <<< call-dibs feature <<<
